import styled from 'styled-components';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

export const Container = styled.div`
  display: none;
  border: 1px solid #eeeeee;
  box-shadow: 0px 4px 4px 0px #ffffff;
  padding: 16px;
  border-radius: 8px;

  ${mediaQuery.desktop`
    display: block;
    border: 1px solid #eeeeee;
  box-shadow: 0px 4px 4px 0px #ffffff;
  padding: 16px;
  border-radius: 8px;
  `}

  .body {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .show {
    font-size: 10px;
    color: #549a9a;
    font-weight: 400;
    padding-left: 30px;
    cursor: pointer;
  }
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;

  .title {
    font-size: 18px;
    font-weight: 500;
  }

  .clear {
    font-size: 12px;
    font-weight: 500;
    color: #549a9a;
    cursor: pointer;
  }
`;
